var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"dark":""}},[_c('v-card-text',{staticClass:"py-5"},[_c('h6',{staticClass:"display-2"},[_vm._v("Módulo Ventas")]),_c('span',{staticClass:"subheading"},[_vm._v("Productos, clientes, ofertas, vendedores y reportes")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }